var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 0L27 10.6667V28.2667C27 30.3285 25.3076 32 23.22 32H3.78C1.69236 32 0 30.3285 0 28.2667V3.73333C0 1.67147 1.69236 0 3.78 0H16.2Z",
    fill: "url(#paint0_linear_448_54098)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.667H20.1709C18.0833 10.667 16.2 8.80696 16.2 6.7451V0.000325203L27 10.667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0133 24.8987L11.1388 26.6666H12.0112L10.4472 24.3139L12.0338 22.0237H11.1569L10.0404 23.7648H10.0223L8.8923 22.0237H8.0154L9.58839 24.3451L7.98828 26.6666H8.86066L9.9952 24.8987H10.0133Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7389 26.6666H13.5254V20.2246H12.7389V26.6666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5062 23.305C14.5062 23.9746 14.9357 24.3809 15.8216 24.5907L16.5674 24.7693C17.1053 24.8987 17.2906 25.0907 17.2906 25.4255C17.2906 25.8451 16.8974 26.113 16.26 26.113C15.6227 26.113 15.2611 25.8585 15.1662 25.3273H14.3797C14.4701 26.1978 15.1571 26.7469 16.26 26.7469C17.3087 26.7469 18.0816 26.1755 18.0816 25.3675C18.0816 24.7023 17.7381 24.3362 16.7889 24.1085L16.0431 23.93C15.5187 23.805 15.2792 23.5862 15.2792 23.2648C15.2792 22.8585 15.6589 22.5773 16.2329 22.5773C16.8115 22.5773 17.1731 22.8764 17.2319 23.363H17.9822C17.9506 22.5416 17.2635 21.9434 16.2329 21.9434C15.2159 21.9434 14.5062 22.5103 14.5062 23.305Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_54098",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ABF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009F57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.2234bfdefa3a3b3d68230a232ca7b8aa.svg";
export { ForwardRef as ReactComponent };